<div #headerContainer [style.height.rem]="1"></div>
